import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
/* import { wordFormByCount } from 'utils/formatting'; */
import { Button } from '@beef/ui-kit';

import { getFeedbackFetchCount, getFeedbackIsLoading } from 'store/ProductDetails/selectors';
import { fetchMoreFeedbacks } from 'store/ProductDetails/feedbackLocal/actions';
import { Preloader } from 'components';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

/**
 * Feedback loader is responsible for:
 * - showing more feedbacks button
 * - showing preloader when its clicked
 * - returning back to normal state when request finished execution
 * - hiding when there are no extra feedbacks to be loaded
 */
const FeedbackLoader = ({ fetchCount, isLoading, onRequestMore, className }) => {
  return fetchCount > 0 ?
      <div className={cx('container', className)}>
        {isLoading ?
          <Preloader />
        : <Button size="m" color="light" onClick={onRequestMore} variant="tertiary" fullWidth>
            {/* Показать ещё {fetchCount} {wordFormByCount(fetchCount, ['отзыв', 'отзыва', 'отзывов'])} */}
            Показать ещё
          </Button>
        }
      </div>
    : null;
};

FeedbackLoader.propTypes = {
  fetchCount: PropTypes.number, // amount of feedbackItems that will be downloaded on the next call
  isLoading: PropTypes.bool, // show preloader when loaded
  onRequestMore: PropTypes.func,
  className: PropTypes.string,
};

const mapStateToProps = (state) => ({
  fetchCount: getFeedbackFetchCount(state),
  isLoading: getFeedbackIsLoading(state),
});

const mapDispatchToProps = {
  onRequestMore: fetchMoreFeedbacks,
};

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackLoader);
